import exExternal from '../external';
import * as exElement from './element';

// ----------------------------------------------------------------------------

const topWrapper = (function (): any {
    function create(config: Record<string, any> = {}): any {
        // Create element (scroll top wrapper)
        const elScrollTopWrapper = exElement.create({
            merge: config,
            class: {
                new: 'scroll-top-wrapper',
            },
            event: {
                click: function (): any {
                    const offsetTop = document.body.offsetTop;

                    exExternal.jquery('html, body').animate(
                        {
                            scrollTop: offsetTop,
                        },
                        500,
                        'linear',
                    );
                },
            },
        });

        // Create event (scroll)
        document.addEventListener('scroll', function (): any {
            // Get element (scroll top wrapper)
            const elScrollTopWrapper = document.querySelector('.scroll-top-wrapper');
            // If there is no element (scroll top wrapper)
            if (!elScrollTopWrapper) {
                return;
            }

            const scrollTop = exExternal.jquery(window).scrollTop() ?? 0;

            if (scrollTop > 300) {
                elScrollTopWrapper.classList.add('show');
            } else {
                elScrollTopWrapper.classList.remove('show');
            }
        });

        // --------------------------------------------------------------------

        // Create element (scroll top inner)
        const elScrollTopInner = exElement.create({
            merge: config.inner,
            tag: 'span',
            class: {
                new: 'scroll-top-inner',
            },
            html: '<i class="fa-solid fa-arrow-up"></i>',
        });
        elScrollTopWrapper.appendChild(elScrollTopInner);

        // --------------------------------------------------------------------

        // Return
        return elScrollTopWrapper;
    }

    function start(): void {
        // Get element (scroll top wrapper)
        const elScrollTopWrapper = document.querySelector('.scroll-top-wrapper');
        // If there is no element (scroll top wrapper)
        if (!elScrollTopWrapper) {
            return;
        }

        // Create event (scroll)
        document.addEventListener('scroll', function (): any {
            const scrollTop = exExternal.jquery(window).scrollTop() ?? 0;

            if (scrollTop > 300) {
                elScrollTopWrapper.classList.add('show');
            } else {
                elScrollTopWrapper.classList.remove('show');
            }
        });

        // Scroll Top Wrapper
        elScrollTopWrapper.addEventListener('click', function (): any {
            const offsetTop = document.body.offsetTop;

            exExternal.jquery('html, body').animate(
                {
                    scrollTop: offsetTop,
                },
                500,
                'linear',
            );
        });
    }

    // ------------------------------------------------------------------------

    return {
        create,
        start,
    };
})();

// ----------------------------------------------------------------------------

export { topWrapper };
